/**
 * The developer overlay's three fixed pieces -- crosshair, panel, copy
 * toast.  packages/client/src/debug.js is handed all three (and #hud, the one panel it
 * toggles that is not its own) by loop.js; the readout rows are built there,
 * not here.
 */
import "./debug.css";
import { mount } from "./dom.js";

export function mountDebug() {
  const cross = mount(`
<div id="debug-cross" class="hidden"></div>`);
  const root = mount(`
<div id="debug" class="panel hidden">
  <div class="debug-title">Debug &middot; F3</div>
  <div id="debug-body"></div>
</div>`);
  const toast = mount(`
<div id="debug-toast" class="panel hidden">copied</div>`);
  return { debug: root, debugBody: root.querySelector("#debug-body"),
           debugCross: cross, debugToast: toast };
}
